import { GetGroupTopAssists as GetGroupTopAssistsAction } from "../../providers/supabase-provider/actions/GetGroupTopAssists";
import type { GetGroupTopAssistsPayload, ITopAssists } from "../../entities";

export const GetGroupTopAssists = async (payload: GetGroupTopAssistsPayload): Promise<ITopAssists[]> => {
  return GetGroupTopAssistsAction(payload);
};
